var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.835 3.255a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m10 0a.85.85 0 0 0-.6.234L3.57 15.156a.86.86 0 0 0 0 1.198.86.86 0 0 0 1.198 0L16.434 4.688a.86.86 0 0 0 0-1.199.85.85 0 0 0-.6-.234m-10 1.667a.834.834 0 1 1 0 1.667.834.834 0 0 1 0-1.667m8.333 6.667a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1.666a.834.834 0 1 1 0 1.667.834.834 0 0 1 0-1.667"
  })));
};
export default SvgPercent;